export enum ApproversTypes {
  CNT = 'CONTROLLER',
  DLA = 'DELEGATED_APPROVER',
  ALL = 'ALL'
}

export enum UserAuthorizer {
  CNT = 'C',
  DLA = 'DA'
}
